import _ from 'lodash'
import Alert from './Alert'

const alertAddedEventName = 'Alert Added'

class AlertService {
  constructor(Alert, $http, $log, $filter, authService, config, $analytics) {
    this.$http = $http
    this.$log = $log
    this.$filter = $filter
    this.$analytics = $analytics
    this.Alert = Alert
    this.authService = authService

    this.baseUrl = config.alertEndpoint + "/alerts"
  }

  query(params = {}, onSuccess, onFail) {
    const queryParams = _.defaults(
      params,
      {userId: this.authService.currentUserId}
    )

    return this.Alert.query(
      queryParams,
      this._onQuerySuccess.bind(this, onSuccess),
      this._onQueryFail.bind(this, onFail)
    )
  }

  _onQuerySuccess(onSuccess, data, headers) {
    const activeAlerts = _(data.alerts)
      .filter({isActive: true})
      .sortByOrder(['title'])
      .value()

    if (onSuccess) onSuccess(activeAlerts)
  }

  _onQueryFail(onFail, response) {
    this.$log.error(data)
    if (onFail) onFail(response)
  }

  queryAlert(alertId, success, fail, alertDate, userId, hmac) {
    const url = this._buildUserQuery(userId) + "/alert/" + alertId

    return this.$http.get(
      url,
      {
        params: {
          addedAt: alertDate.toISOString(),
          hmac: hmac
        }
      })
      .success(success)
      .error(fail)
  }

  addAlert(title, criteria, onSuccess, onFail) {
    const addedAtRemoved = this._removeAddedAt(criteria)
    this.$analytics.timeEvent(alertAddedEventName)
    this.Alert.create(
      {
        title: title,
        filter: this._fixDateTimes(addedAtRemoved),
        userId: this.authService.currentUserId
      },
      this._onAddAlertSuccess.bind(this, onSuccess),
      this._onAddAlertFail.bind(this, onFail)
    )
  }

  _onAddAlertSuccess(onSuccess, data, headers) {
    this.$analytics.eventTrack(
      alertAddedEventName,
      { 'alert id': data.alertId }
    )

    if (onSuccess) onSuccess(data, headers)
  }

  _onAddAlertFail(onFail, response) {
    if (onFail) onFail(response)
  }

  deleteAlert(alertId, callback) {
    this.Alert.remove(
      {
        alertId: alertId,
        userId: this.authService.currentUserId
      },
      { isActive: false },
      this._onDeleteAlertSuccess.bind(this, alertId, callback),
      this._onDeleteAlertFail.bind(this, alertId, callback)
    )
  }

  _onDeleteAlertSuccess(alertId, callback, data, headers) {
    this.$log.info("alert " + alertId + " deleted")
    this.$analytics.eventTrack(
      'Alert Deleted',
      {
        'alert id': alertId
      }
    )
    callback(true)
  }

  _onDeleteAlertFail(alertId, callback, response) {
    this.$log.error(response)
    this.$analytics.eventTrack(
      'Alert Deleted Error',
      {
        'alert id': alertId
      }
    )
    callback(false)
  }

  _buildUserQuery(userId) {
    const requestUserId = userId !== undefined
      ? userId
      : this.authService.currentUserId
    return this.baseUrl + "/user/" + requestUserId
  }

  _removeAddedAt(criteria) {
    return _.omit(criteria, ['addedAtStart', 'addedAtEnd'])
  }

  _fixDateTimes(criteria) {
    var clone = {}
    for (var p in criteria) {
      if (criteria[p] instanceof Date) {
        clone[p] = this.$filter('date')(criteria[p], 'yyyy-MM-dd')
      } else {
        clone[p] = criteria[p]
      }
    }
    return clone;
  }
}

AlertService.$inject = ['Alert', '$http', '$log', '$filter', 'AuthService', 'config', '$analytics']

export default AlertService
